"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeCalcWireAttachmentHeightFieldJoin = void 0;
const field_join_ikecalc_1 = require("./field.join.ikecalc");
const WIRE_ATTACHMENT_HEIGHT = 'wireAttachmentHeight';
class IkeCalcWireAttachmentHeightFieldJoin extends field_join_ikecalc_1.IkeCalcFieldJoin {
    static accepts(field) {
        return field.schema.id === WIRE_ATTACHMENT_HEIGHT;
    }
    constructor(field) {
        super(field);
        this.type = 'IkeCalcWireAttachmentHeightJoin';
    }
    joins(other) {
        const joinableHeight = this.getFieldValue(this.wire, this.field.schema.id);
        if (joinableHeight != null) {
            return false;
        }
        const wireInsulator = this.getFieldValue(this.wire, 'wireInsulator');
        if (this.isDeadend(wireInsulator)) {
            return false;
        }
        if (!other.wire.hasField(this.field.schema.id) || this.getFieldValue(other.wire, this.field.schema.id) != null) {
            return false;
        }
        return (this.spansOpposing(this.span, other.span) &&
            this.fieldsEqual(this.circuit, other.circuit, 'circuitConstruction') &&
            this.fieldsEqual(this.wire, other.wire, 'wireInsulator') &&
            this.fieldsEqual(this.wire, other.wire, 'wireSize') &&
            this.fieldsEqual(this.wire, other.wire, 'wireQuantity'));
    }
}
exports.IkeCalcWireAttachmentHeightFieldJoin = IkeCalcWireAttachmentHeightFieldJoin;
//# sourceMappingURL=field.join.ikecalc.wire.js.map